"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackToggleWishlist = exports.WishListEventType = void 0;
const enums_1 = require("../enums");
const clearGA4EventData_1 = require("./clearGA4EventData");
const pushToDataLayer_1 = require("./pushToDataLayer");
var WishListEventType;
(function (WishListEventType) {
    WishListEventType["AddToWishlist"] = "AddToWishlist";
    WishListEventType["RemoveFromWishlist"] = "RemoveFromWishlist";
})(WishListEventType || (exports.WishListEventType = WishListEventType = {}));
function trackToggleWishlist({ type, productId, productTitle, itemListName, listType, }) {
    (0, clearGA4EventData_1.clearGA4EventData)();
    const isAddToWishlist = type === WishListEventType.AddToWishlist;
    const toggleWishlistEventData = {
        eventCategory: enums_1.EventCategory.Wishlist,
        eventLabel: productId,
        nonInteraction: false,
        event: isAddToWishlist ? 'JS_Event' : enums_1.EventName.EECRemoveFromWishlist,
        eventAction: isAddToWishlist ? enums_1.EventAction.AddToWishlist : enums_1.EventAction.RemoveFromWishlist,
        eventData: {
            eventName: isAddToWishlist
                ? enums_1.GA4EventName.ClickAddToWishlist
                : enums_1.GA4EventName.RemoveFromWishlist,
            feature_category: enums_1.GA4FeatureCategory.Wishlist,
            product_list_name: itemListName,
            product_title: productTitle,
            list_type: listType,
        },
    };
    (0, pushToDataLayer_1.pushToDataLayer)(toggleWishlistEventData);
}
exports.trackToggleWishlist = trackToggleWishlist;
//# sourceMappingURL=trackToggleWishlist.js.map